import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { Text } from "~/components/text";
import { useProduct } from "~/contexts/product-context";
import { convertToDateStr } from "~/shared/utils";
import { BasePanel } from "~/components/base-panel";
import { EmptyText } from "~/components/empty/empty-text";
import { LoadingPanel } from "~/components/panels";

export const AnalysisTab = () => {
  const { t } = useTranslation(["manuscriptDetails"]);
  const { product, loading } = useProduct();

  if (loading) {
    return (
      <LoadingPanel
        title={t("manuscriptDetails:analysis.result")}
        loadingText={t("manuscriptDetails:loading")}
      />
    );
  }

  if (!product?.manuscript?.analysis?.result) {
    return (
      <BasePanel
        title={t("manuscriptDetails:analysis.result")}
        isEmpty
        emptyComponent={
          <EmptyText
            title={t("manuscriptDetails:analysis.noAnalysisFound")}
            text=""
          />
        }
      />
    );
  }

  const { result, generatedAt, generatedContentId, generationRequestId } =
    product.manuscript.analysis;

  return (
    <BasePanel title={t("manuscriptDetails:analysis.result")}>
      <div className="p-4">
        <div className="mb-6 border-b pb-4">
          <Text as="h3" variant="title" className="mb-3">
            {t("manuscriptDetails:analysis.metadata")}
          </Text>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <Text variant="detail">
                {t("manuscriptDetails:analysis.generatedAt")}
              </Text>
              <p>{convertToDateStr(t, generatedAt)}</p>
            </div>
            <div>
              <Text variant="detail">
                {t("manuscriptDetails:analysis.generatedContentId")}
              </Text>
              <p className="truncate">{generatedContentId || "-"}</p>
            </div>
            <div>
              <Text variant="detail">
                {t("manuscriptDetails:analysis.generationRequestId")}
              </Text>
              <p className="truncate">{generationRequestId || "-"}</p>
            </div>
          </div>
        </div>

        <div>
          <Text as="h3" variant="title" className="mb-3">
            {t("manuscriptDetails:analysis.result")}
          </Text>
          <div className="prose max-w-none prose-headings:font-semibold prose-headings:mb-2 prose-headings:mt-4 prose-p:mb-2 prose-p:mt-0 prose-strong:font-semibold prose-ul:mt-1 prose-li:mt-1 prose-li:mb-1">
            <ReactMarkdown>{result}</ReactMarkdown>
          </div>
        </div>
      </div>
    </BasePanel>
  );
};
